import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar'
import Table2 from '../table/Table2'
import SectionTopOfTable from '../general/general-component/section-top-of-table/SectionTopOfTable'
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom'
import InnerLoader from '../general/inner-loader/InnerLoader'
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../general/general-component/abstruct-component/DeleteComponent'
import Warning from '../general/general-component/warning-delete/Warning'
import { ColumnEvaluationType } from '../general/general-component/columns-component/ColumnEvaluationType'
import { deleteEvaluationType, loadEvaluationType } from '../../store/Actions/ActionEvaluationType'
import { VariableEvaluation } from './VariableEvaluation'
import AddEvaluationType from './AddEvaluationType'
import EditEvaluationType from './EditEvaluationType'
import FilterEvaluationType from './FilterEvaluationType'
import { UsePermissions, hasPermissions } from '../general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../general/general-component/check-permissions'
import CheckLazyLoader from '../general/general-component/check-lazy-loader'

const EvaluationType = () => {
  const { permissionss, loadingMainPermission } = UsePermissions();
  const evaluation_types = hasPermissions([{ name: "evaluation-types" }], permissionss);
  const { dispatch, langLocal, navigate } = AbstructVar()
  const { translate } = AbstructLang()
  const { evaluation, loadingevaluation } = useSelectorCustom()
  const { state, setOpen, handleEdit, setopenEdit } = VariableEvaluation()
  const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
  const [evaluationArr, setEvaluationArr] = useState([])
  const [isDeleted, setIsDeleted] = useState('')
  const [idDeleted, setIdDeleted] = useState(null)
  useEffect(() => {
    if (isDeleted && idDeleted) {
      const updatedArr = [...evaluationArr];
      const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
      if (indexToDelete !== -1) {
        updatedArr.splice(indexToDelete, 1);
        setEvaluationArr(updatedArr);
      }
    }
  }, [isDeleted, idDeleted, evaluationArr]);
  useEffect(() => {
    if (evaluation?.length >= 0) {
      setEvaluationArr(evaluation)
    }
  }, [evaluation]);
  useEffect(() => {
    dispatch(loadEvaluationType(navigate))
  }, []);
  const handleDelete = (id) => {
    dispatch(deleteEvaluationType(id, setloadDel, setIsDeleted, setIdDeleted));
  }
  const openEvaluationType = e => {
    e.preventDefault()
    setOpen(true)
  }
  const { columns } = ColumnEvaluationType(translate, warning, handleEdit)
  return (
    <CheckLazyLoader>
      <CheckPermissions array={evaluation_types} loadingMainPermission={loadingMainPermission} >
        <main>
          <FilterEvaluationType translate={translate} />
          <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
            <SectionTopOfTable langLocal={langLocal} title={translate('Evaluation Type')} titleBtn={translate('Add')} FunctionBtn={openEvaluationType} />
            {
              loadingevaluation == false ? (
                <Table2 col={columns} roo={evaluationArr} />
              ) : <InnerLoader />
            }
          </div>
        </main>
      </CheckPermissions>

      {
        state.open && (
          <AddEvaluationType open={state.open} setOpen={setOpen} />
        )
      }
      {
        stateD.deletee == true ? (
          <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
        ) : <></>
      }
      {
        state.openEdit && (
          <EditEvaluationType arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
        )
      }
    </CheckLazyLoader>
  )
}

export default EvaluationType

